import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router'

interface Props {
  unsavedChanges: boolean
  onConfirm?: () => void
  onCancel?: () => void
}
export const BlockLeavingPage = ({ unsavedChanges, onConfirm, onCancel }: Props) => {
  const [openLeavePageDialog, setOpenLeavePageDialog] = useState(false)
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      unsavedChanges && currentLocation.pathname !== nextLocation.pathname,
  )
  const { t } = useTranslate()

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setOpenLeavePageDialog(true)
    }
  }, [blocker.state])

  //Block browser/tab close
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (unsavedChanges) {
        event.preventDefault()
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [unsavedChanges])

  const handleLeavePage = async () => {
    onConfirm?.()
    setOpenLeavePageDialog(false)

    if (blocker.state === 'blocked') blocker.proceed()
  }

  const handleStayPage = () => {
    onCancel?.()
    setOpenLeavePageDialog(false)
    if (blocker.state === 'blocked') blocker.reset()
  }

  return (
    <Dialog onClose={handleStayPage} open={openLeavePageDialog} maxWidth='md'>
      <DialogTitle>{t('leaveThisPage', 'Leave this page?')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Typography>
            {t(
              'youHaveUnsavedChangesThatWillBeLostIfYouLeaveThisPage',
              'You have unsaved changes that will be lost if you leave this page.',
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Stack flexDirection='row' gap={2}>
          <Button variant='contained' color='primary' onClick={handleLeavePage}>
            {t('yesLeave', 'Yes, leave')}
          </Button>
          <Button variant='text' onClick={handleStayPage} color='inherit'>
            {t('stay', 'Stay')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
